import React from "react";
import TextField from "material-ui/TextField";
import TextInput from "@techsoftware/happay-widgets/TextInput";

import i18n from "../i18nNext";

export default class CustomTextField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eyeOpen: false
        };
        this.toggleEye = this.toggleEye.bind(this);
    }

    toggleEye() {
        const { eyeOpen } = this.state;
        this.setState({
            eyeOpen: !eyeOpen
        });
    }

    render() {
        let {
            inputRef,
            style,
            label,
            type,
            disabled,
            floatingLabelStyle,
            prefix,
            suffix,
            inputStyle,
            required,
            multiLine,
            floatingLabelText,
            errorText,
            hintText,
            infoIcon,
            autoComplete,
            value,
            removeMargin,
            parentWrapperClass,
            ...remaining
        } = this.props;
        const { eyeOpen } = this.state;
        let pLenght = prefix ? prefix.length : 0;
        const idObj = { id: this.props.id };
        if (this.props.isWidgetComp) {
            const wrapperClass = `${
                removeMargin ? "" : "hw-customTextInput-wrapper"
            } ${parentWrapperClass || ""}`;
            return (
                <TextInput
                    {...this.props}
                    id={this.props.id}
                    type={type}
                    inputRef={this.props.ref || "inputRef"}
                    disabled={disabled}
                    value={value}
                    onChange={this.props.onChange}
                    hintText={hintText || floatingLabelText}
                    required={required}
                    floatingLabelText={floatingLabelText}
                    errorText={errorText}
                    style={style}
                    prefix={prefix}
                    suffix={suffix}
                    onBlur={this.props.onBlur}
                    onKeyDown={this.props.onKeyDown}
                    iconType={this.props.iconType}
                    showEyeIcon={this.props.showEyeIcon}
                    autoComplete={this.props.autoComplete || "off"}
                    autoFocus={this.props.autoFocus}
                    maxLength={this.props.maxLength}
                    onPaste={this.props.onPaste}
                    onCopy={this.props.onCopy}
                    // customInputParentStyle={Object.assign({}, this.props.customInputParentStyle, { margin: "36px 0px" })}
                    customInputParentStyle={this.props.customInputParentStyle}
                    multiLine={multiLine}
                    // parentWrapperClass={removeMargin ? "" : `hw-customTextInput-wrapper ` }
                    parentWrapperClass={wrapperClass}
                    clearMargin={true}
                    borderType={"light"}
                    errorType={this.props.errorType || (errorText ? "error" : "")}
                />
            );
        }
        return (
            <div
                {...idObj}
                data-ftype="text"
                style={{ opacity: disabled ? 0.8 : 1, width: "100%" }}
            >
                {!this.props.hideLabel && (
                    <div className="material-input-label">
                        {label || floatingLabelText || null}
                        {required ? <span className="required-input">*</span> : null}
                        {infoIcon || null}
                    </div>
                )}
                <div style={{ display: "block", position: "relative" }}>
                    {prefix ? (
                        <span className={`material-input-addOn ${errorText ? "moreBottom" : ""}`}>
                            {prefix}
                        </span>
                    ) : null}
                    <TextField
                        {...remaining}
                        ref={inputRef}
                        name={
                            label ||
                            (typeof floatingLabelText === "object"
                                ? "randomname"
                                : floatingLabelText) ||
                            "randomname"
                        }
                        hintText={
                            hintText ? (
                                hintText
                            ) : typeof floatingLabelText === "string" ? (
                                <span style={{ fontSize: 12 }}>{`${i18n.t(
                                    "flexi.type"
                                )} ${floatingLabelText}`}</span>
                            ) : (
                                ""
                            )
                        }
                        // do not put id as a attribute here , will break in extrafield component.
                        // floatingLabelText={null}
                        //multiLine={multiLine}
                        //floatingLabelStyle={{color:'#54698d',fontFamily: 'Roboto-Regular',fontSize:'12px',letterSpacing:'0.3px'}}
                        hintStyle={{
                            // fontFamily: "Roboto-Regular",
                            fontWeight: 400,
                            fontSize: "14px",
                            bottom: "auto",
                            padding: "0px 0px 8px",
                            paddingLeft: `${pLenght * 9 + "px"}`
                        }}
                        //inputStyle={Object.assign({padding:'0px 0px 8px',paddingLeft:`${(pLenght*9)+'px'}`},(this.state.type == 'password' ? {color:'#16325c',fontFamily: 'Roboto-Regular',fontSize:'20px'} : {color:'#16325c',fontFamily: 'Roboto-Regular',fontSize:'14px'}))}
                        inputStyle={Object.assign(
                            {
                                padding: "0px 0px 8px",
                                // fontFamily: "Roboto-Regular",
                                fontSize: 14,
                                paddingLeft: `${pLenght * 9 + "px"}`
                            },
                            inputStyle || {}
                        )}
                        errorStyle={{
                            fontSize: "10px",
                            bottom: "auto",
                            lineHeight: "initial",
                            padding: "6px 0px 0px"
                        }}
                        //underlineFocusStyle={{border:!errorText?'solid 1px #5e89c6':'solid 1px #F44336'}}
                        type={type === "password" && !eyeOpen ? "password" : type || "text"}
                        required={required}
                        disabled={disabled}
                        errorText={errorText}
                        textareaStyle={{ height: "auto", margin: "0px", padding: "0px" }}
                        fullWidth
                        value={value}
                        autoComplete={autoComplete || "off"}
                        underlineDisabledStyle={{ bottom: "auto", border: "solid .5px #e8edf4" }}
                        underlineStyle={{ bottom: "auto" }}
                        style={Object.assign(
                            { height: "auto", lineHeight: "normal", fontSize: "14px" },
                            style
                        )}
                    />
                    {type === "password" && value && (
                        <button
                            type="button"
                            className="password-eye-button"
                            onClick={this.toggleEye}
                        >
                            <img
                                alt="password-eye"
                                src={`/assets/images/${eyeOpen ? "show" : "hide"}-password.svg`}
                            />
                        </button>
                    )}
                    {suffix ? (
                        <span className={`material-input-suffix ${errorText ? "moreBottom" : ""}`}>
                            {suffix}
                        </span>
                    ) : null}
                </div>
            </div>
        );
    }
}
